import { useCallback, useContext, useEffect, useState } from "react";
import axios from "../../../../api/axios";
import { sleep } from "../../../../functions";
import { useNavigate } from "react-router-dom";
import ProductDetailsContext from "./context";
import useAlert from "../../../../globalComponents/useAlerts";

export const useProductDetailsManager = (productId) => {
  const navigate = useNavigate();
  const { showLoading, showAlert, dismissLoading } = useAlert();
  const [loading, setLoading] = useState(true);

  const [product, setProduct] = useState({
    title: "",
    description: "",
    imageUrl: "",
  });

  const getProduct = async () => {
    try {
      const data = await axios.get("/products/" + productId);

      setProduct((c) => ({ ...c, ...data }));
    } catch (err) {
      showAlert({
        title: "Erro",
        description: "Verifique os parâmetros enviados e tente novamente.",
        onClose: () => navigate("./../"),
      });
    } finally {
      setTimeout(() => setLoading(false), 1500);
    }
  };

  const updateProduct = useCallback(
    async (form, cb) => {
      try {
        showLoading();

        let data = null;

        if (!product.imageUrl && !form.imageFile)
          throw new Error("Adiciona uma imagem ao produto!");

        if (form.imageFile instanceof File) {
          const formData = new FormData();
          Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
          });

          data = await axios.putForm("/products/" + productId, formData);
        } else {
          data = await axios.put("/products/" + productId, form);
        }

        setProduct((c) => ({ ...c, ...data }));
        if (typeof cb === "function") cb();

        await sleep(1000);

        showAlert({
          title: "Concluído",
          description: "Informações atualizadas com sucesso",
        });
      } catch (err) {
        showAlert({ title: "Houve um erro", description: err.message });
      } finally {
      }
    },
    [product],
  );

  useEffect(() => {
    Promise.all([getProduct()]);
  }, []);

  return {
    loading,
    product,
    updateProduct,
  };
};

export const useProductDetails = () => useContext(ProductDetailsContext);
